<div class="fullcontentouter">
  @if (showheader()) {
  <app-headermenu></app-headermenu>
  <div class="row">
    <router-outlet></router-outlet>
  </div>
  }
  @else{
  <app-user-login></app-user-login>
  }

</div>
